export const PROJECT_DESCRIPTION_PREFIX = 'PROJECTS_MODULE.ProjectForms';
